import { render, staticRenderFns } from "./VisitasResumoRede.vue?vue&type=template&id=1f0b53ba&scoped=true&xmlns%3Av-card=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./VisitasResumoRede.vue?vue&type=script&lang=js"
export * from "./VisitasResumoRede.vue?vue&type=script&lang=js"
import style0 from "./VisitasResumoRede.vue?vue&type=style&index=0&id=1f0b53ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b53ba",
  null
  
)

export default component.exports